import React from "react";
import * as ReactDOMClient from "react-dom/client";
import App from "./App";
import { MaterialUIControllerProvider } from "./context";
import { BrowserRouter } from "react-router-dom";
import LoadingContext from "./context/loadingcontext";
import AuthContextProvider from "./context/AuthContext";
import { SnackbarProvider } from "./components/SnackbarProvider";

const container = document.getElementById("root");
const root = ReactDOMClient.createRoot(container);

navigator.serviceWorker
  .register("/firebase-messaging-sw.js")
  .then((registration) => {
    console.log("Service Worker registered:", registration);
  })
  .catch((err) => {
    console.log("Service Worker registration failed:", err);
  });

root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <LoadingContext>
        <SnackbarProvider>
          <AuthContextProvider>
            <App />
          </AuthContextProvider>
        </SnackbarProvider>
      </LoadingContext>
    </MaterialUIControllerProvider>
  </BrowserRouter>
);
